import { portfolioProjects, templates } from '@/data/siteData';
import { articleContent } from '@/data/articleContent';

export interface SearchItem {
  title: string;
  description: string;
  type: 'Page' | 'Case Study' | 'Blog' | 'Template';
  url: string;
  image?: string;
  tags?: string[];
}

export const getSearchIndex = (): SearchItem[] => {
  const staticPages: SearchItem[] = [
    { title: 'Home', description: 'Laurel Web Co. — Accessible Web Development for Nonprofits and Community Organizations.', type: 'Page', url: '/' },
    { title: 'About', description: 'Learn about our mission to build a more accessible web for specialized organizations.', type: 'Page', url: '/about' },
    { title: 'Services', description: 'Our accessibility-first web development packages and care plans.', type: 'Page', url: '/services' },
    { title: 'Portfolio', description: 'Work built for missions that matter. Browse our recent case studies.', type: 'Page', url: '/portfolio' },
    { title: 'Contact', description: 'Book a free consultation or send us a message about your project.', type: 'Page', url: '/contact' },
    { title: 'Resources', description: 'Free guides and resources for mission-driven organizations.', type: 'Page', url: '/resources' },
    { title: 'Templates', description: 'Nonprofit-ready templates to get your organization online in a weekend.', type: 'Page', url: '/templates' },
  ];

  const caseStudies: SearchItem[] = portfolioProjects.map(p => ({
    title: p.name,
    description: p.tagline,
    type: 'Case Study',
    url: `/portfolio/${p.slug}`,
    image: p.heroImage,
    tags: [p.orgType, ...p.techStack]
  }));

  // Build from articleContent so all 60 articles are indexed with correct slugs
  const blogs: SearchItem[] = Object.entries(articleContent).map(([slug, article]) => ({
    title: article.title,
    description: article.subtitle || article.sections?.[0]?.body?.[0] || '',
    type: 'Blog',
    url: `/resources/${slug}`,
    image: `/images/articles/${slug}.png`,
    tags: [article.category],
  }));

  const templateItems: SearchItem[] = templates.map(t => ({
    title: t.name,
    description: `Accessibility-first ${t.niche} template.`,
    type: 'Template',
    url: `/templates/${t.slug}`,
    tags: [t.niche, ...t.features]
  }));

  return [...staticPages, ...caseStudies, ...blogs, ...templateItems];
};
